import React, { useCallback, useEffect, useState } from 'react';
import './styles.scss';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { VEHICLES_HEADERS } from '../../constants/table-headers';
import { ModalDelete, Table } from '..';
import { populateVehicles } from '../../store/ducks/tables/actions';
import { ApplicationState } from '../../store';
import { api } from '../../services/api';
import ActivityIndicator from '../ActivityIndicator';
import { getToken } from '../../services/auth';

const TableVehicles: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const token = getToken();
  const { vehicles } = useSelector(({ tables }: ApplicationState) => ({
    vehicles: tables.vehicles,
  }));
  const [loading, setLoading] = useState<boolean>(false);
  const [id, setId] = useState<number>(0);
  const [modalFlag, setModalFlag] = useState<boolean>(false);

  const loadVehicles = useCallback(() => {
    setLoading(true);
    api
      .get('/admins/vehicle_data', { headers: { Authorization: token } })
      .then(response => {
        if (response.data.error) {
          toast.error(`${response.data.error}`);
          setLoading(false);
          return;
        }
        setLoading(false);
        dispatch(populateVehicles(response.data));
      });
  }, [dispatch, token]);

  const onNavigationClick = useCallback(
    (path: string) => {
      history.push(path);
    },
    [history],
  );

  const deleteVehicle = (id: number) => {
    setLoading(true);
    api
      .delete(`/admins/vehicle_data/${id}`, {
        headers: { Authorization: token },
      })
      .then(response => {
        if (response.data.error) {
          toast.error(`${response.data.error}`);
          setLoading(false);
          return;
        }
        loadVehicles();
        toast.success('Tipo de Veículo deletado com sucesso!');
        setLoading(false);
      });
  };

  useEffect(() => {
    if (vehicles && !vehicles.length) {
      loadVehicles();
    }
  }, [dispatch]);

  if (loading) {
    return <ActivityIndicator />;
  }

  return (
    <div className="container-table-vehicles">
      <ModalDelete
        onHide={() => setModalFlag(false)}
        show={modalFlag}
        onConfirmClick={() => deleteVehicle(id)}
      />

      <Table
        columns={VEHICLES_HEADERS}
        data={vehicles}
        onViewClick={(id: number) =>
          onNavigationClick(`/home/vehicles/view/${id}`)
        }
        onEditClick={(id: number) =>
          onNavigationClick(`/home/vehicles/edit/${id}`)
        }
        onDeleteClick={(id: number) => {
          setModalFlag(true);
          setId(id);
        }}
      />
    </div>
  );
};

export default TableVehicles;
